import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Index/Navbar";
import { API_BASE_URL } from "@/utils/api";

const customStyles = `
  .form-input {
      width: 100%;
      padding: 0.875rem 1rem;
      border: 1px solid #E5E7EB;
      border-radius: 12px;
      font-size: 0.95rem;
      transition: all 0.2s;
      background: #FAFAFA;
      color: #1F2937;
  }
  .form-input:focus {
      border-color: #F05423;
      background: #fff;
      outline: none;
      box-shadow: 0 0 0 3px rgba(240, 84, 35, 0.1);
  }
  .country-select {
      background-color: #F3F4F6;
      border: 1px solid #E5E7EB;
      border-right: none;
      border-radius: 12px 0 0 12px;
      padding-left: 0.75rem;
      padding-right: 2rem;
      font-weight: 500;
      color: #1F2937;
      cursor: pointer;
      outline: none;
      appearance: none;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
      background-position: right 0.2rem center;
      background-repeat: no-repeat;
      background-size: 1.5em 1.5em;
      min-width: 110px;
      font-family: "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif;
  }
  .country-select:focus {
      border-color: #F05423;
      box-shadow: 0 0 0 3px rgba(240, 84, 35, 0.1);
      z-index: 10;
  }
  .level-btn {
      border: 1px solid #E5E7EB;
      background: white;
      color: #6B7280;
      transition: all 0.2s;
  }
  .level-btn:hover {
      border-color: #F05423;
      color: #F05423;
  }
  .level-btn.active {
      background: #FFF0EB;
      border-color: #F05423;
      color: #F05423;
      font-weight: 600;
  }
  .btn-submit {
      background: linear-gradient(to right, #D93025, #F05423);
      transition: opacity 0.3s;
  }
  .btn-submit:hover { opacity: 0.9; }
  
  .ad-card {
      background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .ad-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 25px -5px rgba(79, 70, 229, 0.4), 0 10px 10px -5px rgba(79, 70, 229, 0.2);
  }
  .ad-btn {
      background: white;
      color: #4F46E5;
      font-weight: 700;
      transition: all 0.2s;
  }
  .ad-btn:hover {
      background: #EEF2FF;
      transform: scale(1.05);
  }

  @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
  .animate-fade-in { animation: fadeIn 0.5s ease-out forwards; }
`;

interface CountryData {
  name: string;
  code: string;
  phoneCode: string;
}

const countryList: CountryData[] = [
  { name: "Indonesia", code: "ID", phoneCode: "+62" },
  { name: "Afghanistan", code: "AF", phoneCode: "+93" },
  { name: "Australia", code: "AU", phoneCode: "+61" },
  { name: "Belgium", code: "BE", phoneCode: "+32" },
  { name: "Brazil", code: "BR", phoneCode: "+55" },
  { name: "Canada", code: "CA", phoneCode: "+1" },
  { name: "China", code: "CN", phoneCode: "+86" },
  { name: "Denmark", code: "DK", phoneCode: "+45" },
  { name: "Egypt", code: "EG", phoneCode: "+20" },
  { name: "France", code: "FR", phoneCode: "+33" },
  { name: "Germany", code: "DE", phoneCode: "+49" },
  { name: "Hong Kong", code: "HK", phoneCode: "+852" },
  { name: "India", code: "IN", phoneCode: "+91" },
  { name: "Italy", code: "IT", phoneCode: "+39" },
  { name: "Japan", code: "JP", phoneCode: "+81" },
  { name: "Malaysia", code: "MY", phoneCode: "+60" },
  { name: "Netherlands", code: "NL", phoneCode: "+31" },
  { name: "New Zealand", code: "NZ", phoneCode: "+64" },
  { name: "Philippines", code: "PH", phoneCode: "+63" },
  { name: "Russia", code: "RU", phoneCode: "+7" },
  { name: "Saudi Arabia", code: "SA", phoneCode: "+966" },
  { name: "Singapore", code: "SG", phoneCode: "+65" },
  { name: "South Korea", code: "KR", phoneCode: "+82" },
  { name: "Spain", code: "ES", phoneCode: "+34" },
  { name: "Sweden", code: "SE", phoneCode: "+46" },
  { name: "Switzerland", code: "CH", phoneCode: "+41" },
  { name: "Taiwan", code: "TW", phoneCode: "+886" },
  { name: "Thailand", code: "TH", phoneCode: "+66" },
  { name: "Turkey", code: "TR", phoneCode: "+90" },
  { name: "United Kingdom", code: "GB", phoneCode: "+44" },
  { name: "United States", code: "US", phoneCode: "+1" },
  { name: "Vietnam", code: "VN", phoneCode: "+84" },
];

interface FormData {
  fullName: string;
  email: string;
  phoneNumber: string;
  countryCode: string;
  interestedClass: string;
  level: string;
  learningGoal: string;
  preferredDay: string;
  preferredTime: string;
  timeZone: string;
  informationSource: string;
  additionalInfo: string;
}

const classOptions = ["Private Class (1-on-1)", "Semi-Private Class"];
const levelOptions = [
  "Beginner",
  "Elementary",
  "Intermediate",
  "Upper-Intermediate",
  "Advanced",
  "I'm not sure",
];
const learningGoalOptions = [
  "Speaking & Conversation",
  "Listening & Comprehension",
  "Reading & Writing",
  "Grammar",
  "Indonesian for Travel",
  "Indonesian for Work",
  "Cultural Understanding",
];
const informationSourceOptions = [
  "Instagram",
  "Google / Search",
  "Recommendation",
  "Friend / Family",
];
const timeZoneOptions = [
  "UTC-12 (Baker Island)",
  "UTC-11 (American Samoa)",
  "UTC-10 (Hawaii)",
  "UTC-9 (Alaska)",
  "UTC-8 (Pacific Time)",
  "UTC-7 (Mountain Time)",
  "UTC-6 (Central Time)",
  "UTC-5 (Eastern Time)",
  "UTC-4 (Atlantic Time)",
  "WIB (UTC+7)",
  "WITA (UTC+8)",
  "WIT (UTC+9)",
  "UTC-3 (Argentina)",
  "UTC-1 (Azores)",
  "UTC+0 (London, Lisbon)",
  "UTC+1 (Central Europe)",
  "UTC+2 (Eastern Europe, South Africa)",
  "UTC+3 (Moscow, East Africa)",
  "UTC+4 (Gulf Standard Time)",
  "UTC+5 (Pakistan)",
  "UTC+5:30 (India, Sri Lanka)",
  "UTC+6 (Bangladesh)",
  "UTC+6:30 (Myanmar)",
  "UTC+8 (Singapore, China)",
  "UTC+9 (Japan, Korea)",
  "UTC+9:30 (Central Australia)",
  "UTC+10 (Eastern Australia)",
  "UTC+11 (Solomon Islands)",
  "UTC+12 (New Zealand)",
  "UTC+13 (Tonga)",
  "UTC+14 (Line Islands)",
];
const preferredDayOptions = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const preferredTimeOptions = [
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
];

type SubmissionStatus = "idle" | "pending" | "success" | "error";

const TrialClass: React.FC = () => {
  const getFlagEmoji = (countryCode: string) => {
    const codePoints = countryCode
      .toUpperCase()
      .split("")
      .map((char) => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  };

  const [formData, setFormData] = useState<FormData>({
    fullName: "",
    email: "",
    phoneNumber: "",
    countryCode: "+62",
    interestedClass: "",
    level: "",
    learningGoal: "",
    preferredDay: "",
    preferredTime: "",
    timeZone: "",
    informationSource: "",
    additionalInfo: "",
  });

  const [status, setStatus] = useState<SubmissionStatus>("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState<string[]>([]);
  const [learningGoalOther, setLearningGoalOther] = useState("");
  const [informationSourceOther, setInformationSourceOther] = useState("");

  const statusRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkStatus = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await fetch(`${API_BASE_URL}/trial-class/status`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();

          if (response.ok && data.success && data.hasRegistered) {
            setStatus("success");
          } else {
            console.warn(
              "User belum terregistrasi atau token tidak valid:",
              data.message,
            );
          }
        } else {
          console.error(
            `Server merespons dengan status ${response.status} (Bukan JSON)`,
          );
        }
      } catch (err) {
        console.error("Gagal cek status registrasi:", err);
      }
    };

    checkStatus();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    if (name === "phoneNumber") {
      const numericValue = value.replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFieldSelect = (field: keyof FormData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrors([]);

    const target = e.currentTarget as HTMLFormElement;
    const browserFormData = new FormData(target);

    const submittedFullName =
      browserFormData.get("fullName")?.toString().trim() ||
      formData.fullName.trim();
    const submittedEmail =
      browserFormData.get("email")?.toString().trim() || formData.email.trim();
    const submittedPhoneNumber = (
      browserFormData.get("phoneNumber")?.toString().replace(/\D/g, "") ||
      formData.phoneNumber
    ).trim();
    const selectedLearningGoal =
      browserFormData.get("learningGoal")?.toString().trim() ||
      formData.learningGoal.trim();
    const submittedLearningGoal =
      selectedLearningGoal === "Other"
        ? `Other: ${learningGoalOther.trim()}`
        : selectedLearningGoal;
    const submittedInterestedClass =
      browserFormData.get("interestedClass")?.toString().trim() ||
      formData.interestedClass.trim();
    const submittedPreferredDay =
      browserFormData.get("preferredDay")?.toString().trim() ||
      formData.preferredDay.trim();
    const submittedPreferredTime =
      browserFormData.get("preferredTime")?.toString().trim() ||
      formData.preferredTime.trim();
    const submittedPreferredSchedule =
      submittedPreferredDay && submittedPreferredTime
        ? `${submittedPreferredDay} - ${submittedPreferredTime}`
        : "";
    const submittedTimeZone =
      browserFormData.get("timeZone")?.toString().trim() ||
      formData.timeZone.trim();
    const selectedInformationSource =
      browserFormData.get("informationSource")?.toString().trim() ||
      formData.informationSource.trim();
    const submittedInformationSource =
      selectedInformationSource === "Other"
        ? `Other: ${informationSourceOther.trim()}`
        : selectedInformationSource;
    const submittedAdditionalInfo =
      browserFormData.get("additionalInfo")?.toString().trim() ||
      formData.additionalInfo.trim();

    const newErrors: string[] = [];
    if (!submittedFullName) newErrors.push("Full name is required");
    if (!submittedEmail) newErrors.push("Email is required");
    else if (!isValidEmail(submittedEmail)) newErrors.push("Invalid email");
    if (!submittedPhoneNumber) newErrors.push("Phone number is required");
    if (!submittedInterestedClass)
      newErrors.push("Interested class is required");
    if (!formData.level) newErrors.push("Level is required");
    if (!selectedLearningGoal) newErrors.push("Learning goal is required");
    if (selectedLearningGoal === "Other" && !learningGoalOther.trim())
      newErrors.push("Please specify your learning goal");
    if (!submittedPreferredDay) newErrors.push("Preferred day is required");
    if (!submittedPreferredTime) newErrors.push("Preferred time is required");
    if (!submittedTimeZone) newErrors.push("Time zone is required");
    if (!selectedInformationSource)
      newErrors.push("Information source is required");
    if (selectedInformationSource === "Other" && !informationSourceOther.trim())
      newErrors.push("Please specify how you heard about us");

    if (newErrors.length > 0) {
      setErrors(newErrors);
      return;
    }

    setStatus("pending");

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setErrorMessage("Silakan login terlebih dahulu untuk mendaftar kelas.");
        setStatus("error");
        return;
      }

      const payload = {
        full_name: submittedFullName,
        email: submittedEmail,
        phone_number: submittedPhoneNumber,
        country_code: formData.countryCode,
        country:
          countryList.find(
            (country) => country.phoneCode === formData.countryCode,
          )?.name || "",
        interested_class: submittedInterestedClass,
        level: formData.level,
        learning_goal: submittedLearningGoal,
        preferred_schedule: submittedPreferredSchedule,
        time_zone: submittedTimeZone,
        information_source: submittedInformationSource,
        additional_info: submittedAdditionalInfo,
      };

      const apiUrl = `${API_BASE_URL}/trial-class`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      let data: any = null;
      try {
        data = await response.json();
      } catch (err) {}

      console.debug("API URL:", apiUrl);
      console.debug("Request payload:", payload);
      console.debug(
        "Server response status:",
        response.status,
        response.statusText,
      );
      console.debug("Server response body:", data);

      if (response.ok) {
        setStatus("success");
        if (statusRef.current) {
          statusRef.current.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        console.error("Trial registration failed", {
          status: response.status,
          statusText: response.statusText,
          body: data,
        });
        setErrorMessage(
          data?.message ||
            `Server error ${response.status}: ${response.statusText || "Terjadi kesalahan pada server."}`,
        );
        setStatus("error");
      }
    } catch (error) {
      console.error("Fetch error on /api/trial-class:", error);
      const message = error instanceof Error ? error.message : String(error);
      setErrorMessage(`Gagal menghubungi server: ${message}`);
      setStatus("error");
    }
  };

  return (
    <div className="bg-white min-h-screen font-poppins text-gray-800">
      <Navbar />
      <style>{customStyles}</style>

      <main className="max-w-7xl mx-auto px-6 py-10 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start">
          {/* === KOLOM KIRI: FORM === */}
          <div className="order-2 lg:order-1 animate-fade-in flex flex-col gap-10">
            <div>
              <div className="mb-8">
                <h1 className="text-3xl md:text-5xl font-extrabold text-[#991B1B] mb-4 leading-tight">
                  Take Your Indonesian Further
                </h1>
                <p className="text-gray-500 text-base md:text-lg">
                  Join Fluenesia and gain access to exclusive learning materials
                  and personalised guidance from experienced tutors.
                </p>
              </div>

              {status === "success" ? (
                <div
                  ref={statusRef}
                  className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center"
                >
                  <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl">
                    <i className="fas fa-check"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    Pendaftaran Berhasil!
                  </h3>
                  <p className="text-gray-600 mb-6">
                    Terima kasih! Anda sudah terdaftar.
                    <br />
                    Tim kami akan segera menghubungi Anda.
                  </p>
                  <Link
                    to="/"
                    className="text-[#F05423] font-bold hover:underline"
                  >
                    Kembali ke Beranda
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  {status === "error" && (
                    <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm mb-4">
                      {errorMessage}
                    </div>
                  )}
                  {errors.length > 0 && (
                    <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm mb-4 list-disc pl-5">
                      {errors.map((e, i) => (
                        <li key={i}>{e}</li>
                      ))}
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      autoComplete="name"
                      className="form-input"
                      placeholder="[ Enter your full name ]"
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="email"
                      autoComplete="email"
                      className="form-input"
                      placeholder="[ Enter your email address ]"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <div className="flex relative">
                      <select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleChange}
                        className="country-select"
                      >
                        {countryList.map((c) => (
                          <option key={c.code} value={c.phoneCode}>
                            {getFlagEmoji(c.code)} {c.code} ({c.phoneCode})
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        name="phoneNumber"
                        autoComplete="tel"
                        className="form-input rounded-l-none border-l-0"
                        placeholder="8123xxxx"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Which class are you interested in?
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {classOptions.map((option) => (
                        <label
                          key={option}
                          className={`level-btn p-3 rounded-xl text-sm font-medium cursor-pointer ${formData.interestedClass === option ? "active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="interestedClass"
                            value={option}
                            checked={formData.interestedClass === option}
                            onChange={() =>
                              handleFieldSelect("interestedClass", option)
                            }
                            className="sr-only"
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      What is your current Indonesian level?
                    </label>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      {levelOptions.map((option) => (
                        <label
                          key={option}
                          className={`level-btn p-3 rounded-xl text-sm font-medium cursor-pointer ${formData.level === option ? "active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="level"
                            value={option}
                            checked={formData.level === option}
                            onChange={() => handleFieldSelect("level", option)}
                            className="sr-only"
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      What are your main learning goals?
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {[...learningGoalOptions, "Other"].map((option) => (
                        <label
                          key={option}
                          className={`level-btn p-3 rounded-xl text-sm font-medium cursor-pointer ${formData.learningGoal === option ? "active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="learningGoal"
                            value={option}
                            checked={formData.learningGoal === option}
                            onChange={() =>
                              handleFieldSelect("learningGoal", option)
                            }
                            className="sr-only"
                          />
                          {option === "Other" ? "Other: ..." : option}
                        </label>
                      ))}
                    </div>
                    {formData.learningGoal === "Other" && (
                      <input
                        type="text"
                        className="form-input mt-3"
                        placeholder="Please specify your learning goal"
                        value={learningGoalOther}
                        onChange={(event) =>
                          setLearningGoalOther(event.target.value)
                        }
                      />
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Preferred Class Schedule
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <select
                        name="preferredDay"
                        className="form-input"
                        value={formData.preferredDay}
                        onChange={handleChange}
                      >
                        <option value="">Select a day</option>
                        {preferredDayOptions.map((day) => (
                          <option key={day} value={day}>
                            {day}
                          </option>
                        ))}
                      </select>
                      <select
                        name="preferredTime"
                        className="form-input"
                        value={formData.preferredTime}
                        onChange={handleChange}
                      >
                        <option value="">Select a time</option>
                        {preferredTimeOptions.map((time) => (
                          <option key={time} value={time}>
                            {time}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Preferred Time Zone
                    </label>
                    <select
                      name="timeZone"
                      className="form-input"
                      value={formData.timeZone}
                      onChange={handleChange}
                    >
                      <option value="">Select your time zone</option>
                      {timeZoneOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      How did you hear about us?
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {[...informationSourceOptions, "Other"].map((option) => (
                        <label
                          key={option}
                          className={`level-btn p-3 rounded-xl text-sm font-medium cursor-pointer ${formData.informationSource === option ? "active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="informationSource"
                            value={option}
                            checked={formData.informationSource === option}
                            onChange={() =>
                              handleFieldSelect("informationSource", option)
                            }
                            className="sr-only"
                          />
                          {option === "Other" ? "Other: ..." : option}
                        </label>
                      ))}
                    </div>
                    {formData.informationSource === "Other" && (
                      <input
                        type="text"
                        className="form-input mt-3"
                        placeholder="Please specify"
                        value={informationSourceOther}
                        onChange={(event) =>
                          setInformationSourceOther(event.target.value)
                        }
                      />
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                      Anything else you'd like us to know?
                    </label>
                    <textarea
                      name="additionalInfo"
                      autoComplete="off"
                      className="form-input"
                      placeholder="[ Tell us about your learning goals, preferences, or anything else that may help us tailor your class. ]"
                      value={formData.additionalInfo}
                      onChange={handleChange}
                      rows={4}
                    />
                  </div>

                  <div className="pt-4">
                    <button
                      type="submit"
                      disabled={status === "pending"}
                      className="w-full btn-submit text-white font-bold text-lg py-4 rounded-xl shadow-lg shadow-orange-500/30 flex justify-center items-center gap-2"
                    >
                      {status === "pending"
                        ? "Processing..."
                        : "Submit Registration"}
                    </button>
                  </div>
                </form>
              )}
            </div>

            {/* === ADS SECTION === */}
            <div className="ad-card relative rounded-3xl p-8 text-white overflow-hidden mt-6">
              <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-white opacity-10 rounded-full blur-2xl"></div>
              <div className="absolute bottom-0 left-0 -ml-10 -mb-10 w-32 h-32 bg-purple-300 opacity-20 rounded-full blur-xl"></div>

              <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 justify-between">
                <div className="text-left flex-1">
                  <div className="inline-block bg-white/20 px-3 py-1 rounded-full text-xs font-semibold mb-3 border border-white/30">
                    🚀 Bingung pilih level?
                  </div>
                  <h3 className="text-2xl font-bold mb-2 leading-tight">
                    Cek Kemampuan Bahasa Inggrismu!
                  </h3>
                  <p className="text-indigo-100 text-sm opacity-90 mb-0">
                    Ikuti Assessment Test gratis hanya dalam 10 menit untuk
                    mengetahui level belajarmu.
                  </p>
                </div>

                <div className="flex-shrink-0 w-full md:w-auto">
                  <Link
                    to="/assessment/free-test"
                    className="ad-btn block w-full text-center px-6 py-3 rounded-xl shadow-lg"
                  >
                    Mulai Tes Gratis
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* === KOLOM KANAN: GAMBAR HERO === */}
          <div className="order-1 lg:order-2 relative animate-fade-in hidden lg:block sticky top-24">
            <div className="w-full h-[600px] bg-gradient-to-br from-[#FF9F43] to-[#F05423] rounded-[40px] relative overflow-hidden flex items-end justify-center shadow-2xl">
              <div className="absolute top-10 right-10 w-32 h-32 bg-white opacity-20 rounded-full blur-2xl"></div>
              <div className="absolute top-1/2 left-0 w-20 h-20 bg-yellow-300 opacity-30 rounded-full blur-xl"></div>

              <div className="absolute bottom-10 left-10 grid grid-cols-4 gap-2 opacity-30">
                {[...Array(16)].map((_, i) => (
                  <div
                    key={i}
                    className="w-1.5 h-1.5 bg-white rounded-full"
                  ></div>
                ))}
              </div>

              <img
                src="/orang.png"
                alt="Student"
                className="relative z-10 w-[90%] object-cover object-top h-[500px] rounded-t-3xl shadow-lg filter brightness-110 contrast-110"
                style={{
                  maskImage:
                    "linear-gradient(to bottom, black 80%, transparent 100%)",
                }}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TrialClass;
